import React, { useEffect, useState } from "react";
import "./AuditionRounds.css";

import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import { Tab, Table, Nav } from "react-bootstrap";
import swal from "sweetalert";
import Button from "../Event/RoundVideoResultFour/Component/Button";
import style2 from "../Event/RoundVideoResultFour/CSS/RoundVideoResult.module.css";
import ReUseableAuditionHeaderTitle from "../../Reuseable/ReUseableAuditionHeaderTitle";
import Card from "../Event/RoundVideoResultThree/Component/Card";
import AuditionLiveJudgeAssesmentModal from "../../Reuseable/AuditionLiveJudgeAssesmentModal";
import ReactPlayer from "react-player";
import AuditionLiveVideoUploadModal from "../../Reuseable/AuditionLiveVideoUploadModal";
import AuditionOxygenVideoUpload from "../../Reuseable/AuditionOxygenVideoUpload";
import { confirmAlert } from "react-confirm-alert";
import { serverInfo } from "../../../App";
import { useContext } from "react";

const AuditionLiveRoundJudgeAssessment = ({ tabActiveRound }) => {
  const { videoCdnUrl } = useContext(serverInfo);

  const [modalShow, setModalShow] = React.useState(false);
  const [videoModalShow, setVideoModalShow] = React.useState(false);
  const [oxygenModal, setoxygenModal] = React.useState(false);

  const [auditionRoundInfo, setAuditionRoundInfo] = useState([]);
  const [videoType, setVideoType] = useState("general");
  const [activeRound, setActiveRound] = React.useState(0);
  const [event, setEvent] = useState({});
  const { slug } = useParams();
  const [auditionParticipants, setAuditionParticipants] = React.useState([]);
  const [user_id, setUserId] = useState();
  const [videoUrl, setVideoUrl] = useState(false);
  const [replyVideos, setReplyVideo] = useState([]);

  const [rounds, setRounds] = useState([]);
  const [isAbleToMerge, setIsAbleToMergeVideo] = useState([]);
  const [count, setCount] = useState(1);
  const [filterNumber, setFilterNumber] = useState(1);
  const [filterType, setFilterType] = useState("");
  const [loading, setLoading] = useState(true);
  const [roundMarkTrackings, setRoundMarkTrackings] = React.useState({});

  const openModal = (user_id) => {
    setModalShow(true);
    setUserId(user_id);
  };
  const openVideoModal = (user_id) => {
    setVideoModalShow(true);
    setUserId(user_id);
  };
  const openOxygenModal = (user_id) => {
    setoxygenModal(true);
    setUserId(user_id);
  };

  const getRoundInfoAndVideos = () => {
    axios
      .get(
        `/api/audition-admin/audition/getEligibleParticipant/${event?.id}/${activeRound}`
      )
      .then((res) => {
        if (res.data?.status === 200) {
          setAuditionRoundInfo(res.data?.auditionRoundInfo);
          setAuditionParticipants(res.data?.participants);
          setIsAbleToMergeVideo(res.data.ableToMargeVideos);
        }
      });
  };

  const fetchAuditionDetails = () => {
    axios.get(`/api/audition-admin/audition-event/with-rounds/${slug}`).then((res) => {
      if (res.data?.status === 200) {
        setEvent(res.data?.event);
        setActiveRound(
          res.data?.event.active_round_info_id == tabActiveRound
            ? res.data?.event.active_round_info_id
            : tabActiveRound
        );
        // if error then add info
        setRounds(res.data?.event?.audition_rounds);
      }
    });
  };

  const handleMergeVideo = () => {
    axios
      .get(
        `/api/audition-admin/audition/auditionRoundVideoMerge/${event?.id}/${activeRound}`
      )
      .then((res) => {
        if (res.data?.status === 200) {
          swal("Success", res.data?.message, "success");
          getRoundInfoAndVideos();
        }
      });
  };

  const showReplyVideo = (user_id) => {
    axios
      .get(
        `/api/audition-admin/audition/oxygen-reply-videos/${event?.id}/${activeRound}/${user_id}`
      )
      .then((res) => {
        if (res.data?.status === 200) {
          setReplyVideo(res.data?.replyVideos);
        }
      });
  };
  const makeOxygenWinner = (user_id) => {
    axios
      .get(
        `/api/audition-admin/audition/make-oxygen-winner/${event?.id}/${activeRound}/${user_id}`
      )
      .then((res) => {
        if (res.data?.status === 200) {
          getRoundInfoAndVideos();
        }
      });
  };

  useEffect(() => {
    getRoundInfoAndVideos();
    setVideoUrl(false);
  }, [activeRound, videoUrl]);

  useEffect(() => {
    fetchAuditionDetails();
  }, [slug]);
  useEffect(() => {
    fetchAuditionDetails();
  }, [tabActiveRound]);

  const handleCountChange = (e) => {
    if (e.target.value > 100 || e.target.value < 0) {
      swal(
        "Opps...",
        "Sorry input field should not more then 100 & short then 0",
        "error"
      );
      setCount(1);
    } else {
      setCount(Number(e.target.value));
    }
  };
  const handleFilterNumberChange = (e) => {
    if (e.target.value < 0) {
      swal("Opps...", "Sorry input field should not short then 0", "error");
      setFilterNumber(1);
    } else {
      setFilterNumber(Number(e.target.value));
    }
  };
  const viewResultByPercentage = () => {
    setFilterType("percentage");
    if (Number(count) > 100 || Number(count) < 0) {
      swal(
        "Opps...",
        "Sorry input field should not more then 100 & short then 0",
        "error"
      );
    } else {
      axios
        .get(
          `/api/audition-admin/audition/singleAuditionRoundVideoResultByPercentage/${event?.id}/${activeRound}/${count}/${videoType}`
        )
        .then((res) => {
          if (res.data?.status === 200) {
            setRoundMarkTrackings(res.data?.percentageBaseRoundMarkTrackings);
            swal(
              "Success",
              "Found " +
                res.data?.percentageBaseRoundMarkTrackings?.length +
                " user for the next round",
              "success"
            );
          }
        });
    }
  };

  const viewResultByFilterNumber = () => {
    setFilterType("number");
    if (Number(filterNumber) < 0) {
      swal("Opps...", "Sorry input field should not short then 0", "error");
    } else {
      axios
        .get(
          `/api/audition-admin/audition/singleAuditionRoundVideoResultByFilterNumber/${event?.id}/${activeRound}/${filterNumber}/${videoType}`
        )
        .then((res) => {
          if (res.data?.status === 200) {
            setRoundMarkTrackings(res.data?.filterNumberBaseRoundMarkTrackings);
            swal(
              "Success",
              "Found " +
                res.data?.filterNumberBaseRoundMarkTrackings?.length +
                " user for the next round",
              "success"
            );
          }
        });
    }
  };

  const userSendToManager = () => {
    const fData = new FormData();
    fData.append("percentage_range", count);
    fData.append("filter_number", filterNumber);
    fData.append("filter_type", filterType);
    fData.append("audition_id", event.id);
    fData.append("round_info_id", activeRound);
    fData.append("type", videoType);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(`/api/audition-admin/audition/roundResultSendToManager`, fData)
        .then((res) => {
          if (res.data?.status == 200) {
            swal("success", res.data?.message, "success");
            setLoading(true);
            getRoundInfoAndVideos();
          }
        });
    });
  };

  function increment() {
    setCount(function (prevCount) {
      if (prevCount < 100) {
        return (prevCount += 1);
      } else {
        return (prevCount = 100);
      }
    });
  }

  function decrement() {
    setCount(function (prevCount) {
      if (prevCount > 0) {
        return (prevCount -= 1);
      } else {
        return (prevCount = 0);
      }
    });
  }
  function incrementNumber() {
    setFilterNumber(function (prevFilterNumber) {
      return (prevFilterNumber += 1);
    });
  }

  function decrementNumber() {
    setFilterNumber(function (prevFilterNumber) {
      if (prevFilterNumber > 0) {
        return (prevFilterNumber -= 1);
      } else {
        return (prevFilterNumber = 0);
      }
    });
  }

  const authName = localStorage.getItem("auth_name");

  const joinCall = (room_id) => {
    // setCallJoinBuffer(true)
    axios
      .get("/sanctum/csrf-cookie")
      .then((response) => {
        axios.get(`/api/sdk/get-token/admin`).then((res) => {
          // setCallJoinBuffer(false)
          // setToken(res.data.token);

          window.open(
            `/video-meeting?token=${res.data.token}&meetingId=${room_id}&webcamEnabled=true&micEnabled=true&name=${authName}&whiteboardEnabled=true&canDrawOnWhiteboard=true&canToggleWhiteboard=true&canChangeLayout=true&canPin=true&askJoin=false&participantCanToggleOtherMic=true&participantCanToggleOtherWebcam=true&canRemoveOtherParticipant=true`
          );
        });
      })
      .catch((err) => {
        // alert('network problem')
      });
  };

  // Confirm Alert

  function makeConfirm() {
    confirmAlert({
      title: "Please Confirm Carefully",
      message: "If once submit, you cant't undo !",
      buttons: [
        {
          label: "Yes",
          onClick: () => handleMergeVideo(),
        },
        {
          label: "No",
          // onClick: () => alert("Click No"),
        },
      ],
    });
  }

  return (
    <>
      {auditionRoundInfo?.oxygen_feed == 1 ? (
        <div className="container">
          <br />
          <h1 className="text-warning text-center">Upload Your Oxygen Video</h1>
          <br />

          <div className="row mt-3 mb-5">
            {replyVideos ? (
              replyVideos?.map((videos) => (
                <>
                  <div className="col-md-2 mb-2">
                    <div className="p-2 card-bg">
                      <ReactPlayer
                        url={videoCdnUrl + videos?.reply_video}
                        controls={true}
                        playing={false}
                        volume={1}
                        height={100}
                        width={180}
                      />
                    </div>
                  </div>
                </>
              ))
            ) : (
              <h3 className="text-light">Reply Video Not Found</h3>
            )}
          </div>

          <div className="container">
            <Table striped bordered hover variant="dark">
              <thead className="text-center">
                <tr>
                  <th className="text-primary">Name</th>
                  <th className="text-primary">Email</th>
                  <th className="text-primary">Video</th>
                  <th className="text-primary">View Reply Video</th>
                  <th className="text-primary">Make Winner</th>
                </tr>
              </thead>
              <tbody>
                {auditionParticipants &&
                  auditionParticipants.map(
                    (auditionParticipant, parentIndex) => (
                      <tr key={parentIndex}>
                        <td className="text-center">
                          {auditionParticipant.user?.first_name +
                            " " +
                            auditionParticipant.user?.last_name}
                        </td>
                        <td className="text-center">
                          {auditionParticipant.user?.email}
                        </td>

                        <td className="text-center">
                          <div className="d-flex justify-content-center text-center">
                            {auditionParticipant?.oxygen_video.length > 0 ? (
                              auditionParticipant?.oxygen_video?.map(
                                (video, index) => (
                                  <>
                                    <ReactPlayer
                                      url={videoCdnUrl + video.video}
                                      controls={true}
                                      playing={false}
                                      volume={1}
                                      height={100}
                                      width={200}
                                    />
                                  </>
                                )
                              )
                            ) : (
                              <div className="d-flex justify-content-center text-center">
                                <>
                                  <button
                                    className="btn btn-warning"
                                    onClick={() =>
                                      openOxygenModal(
                                        auditionParticipant.user?.id
                                      )
                                    }
                                  >
                                    Upload Video
                                  </button>
                                  <AuditionOxygenVideoUpload
                                    userId={user_id}
                                    auditionParticipant={auditionParticipant}
                                    event={event}
                                    show={oxygenModal}
                                    setVideoUrl={setVideoUrl}
                                    onHide={() => setoxygenModal(false)}
                                  />
                                </>
                              </div>
                            )}
                          </div>
                        </td>
                        <td className="text-center">
                          <button
                            onClick={() =>
                              showReplyVideo(auditionParticipant.user?.id)
                            }
                            className="btn btn-sm btn-primary"
                          >
                            View
                            <i className="fa-solid fa-eye mx-2"></i>
                          </button>
                        </td>
                        <td className="text-center">
                          {auditionParticipant?.oxygen_video?.map(
                            (video, index) => (
                              <>
                                {video.status == 2 ? (
                                  <>
                                    <span className="badge rounded-pill bg-success ml-1">
                                      Winner
                                    </span>
                                  </>
                                ) : (
                                  <>
                                    <button
                                      onClick={() =>
                                        makeOxygenWinner(
                                          auditionParticipant.user?.id
                                        )
                                      }
                                      className="btn btn-sm btn-success"
                                    >
                                      <i className="fa-solid fa-check mx-2"></i>
                                    </button>
                                  </>
                                )}
                              </>
                            )
                          )}
                        </td>
                      </tr>
                    )
                  )}
              </tbody>
            </Table>
          </div>
          <br />
        </div>
      ) : (
        <></>
      )}
      <br />
      <div className="text-center">
        <button
          className="btn btn-warning"
          onClick={() => joinCall(auditionRoundInfo?.room_id)}
        >
          Join Now
        </button>
      </div>
      <br />
      <h1 className="text-warning text-center">Upload Video And Judge Mark</h1>
      <div className="container">
        <div style={{ overflowX: "auto" }}>
          <Table striped bordered hover variant="dark">
            <thead>
              <tr>
                <th className="bg-warning text-center">Name</th>
                <th className="bg-warning text-center">Email</th>
                <th className="bg-warning text-center">Video</th>
              </tr>
            </thead>
            <tbody>
              {auditionParticipants &&
                auditionParticipants.map((auditionParticipant, parentIndex) => (
                  <tr key={parentIndex}>
                    <td>
                      {auditionParticipant.user?.first_name +
                        " " +
                        auditionParticipant.user?.last_name}
                    </td>
                    <td>{auditionParticipant.user?.email}</td>
                    <td>
                      <div>
                        {auditionParticipant?.user_uploaded_video.length > 0 ? (
                          auditionParticipant?.user_uploaded_video?.map(
                            (video, index) => (
                              <>
                                <ReactPlayer
                                  url={videoCdnUrl + video.video}
                                  controls={true}
                                  playing={false}
                                  volume={1}
                                  height={100}
                                  width={200}
                                />

                                <button
                                  disabled={
                                    video.judge_video_mark.length ==
                                    JSON.parse(video.judge_id).length
                                      ? true
                                      : false
                                  }
                                  className="btn btn-warning mt-2"
                                  onClick={() =>
                                    openModal(auditionParticipant.user?.id)
                                  }
                                >
                                  Set Marks & Comments
                                </button>

                                <AuditionLiveJudgeAssesmentModal
                                  userId={user_id}
                                  auditionParticipant={auditionParticipant}
                                  event={event}
                                  show={modalShow}
                                  setVideoUrl={setVideoUrl}
                                  onHide={() => setModalShow(false)}
                                />
                              </>
                            )
                          )
                        ) : (
                          <>
                            <button
                              className="btn btn-warning"
                              onClick={() =>
                                openVideoModal(auditionParticipant.user?.id)
                              }
                            >
                              Upload Video
                            </button>
                            <AuditionLiveVideoUploadModal
                              userId={user_id}
                              auditionParticipant={auditionParticipant}
                              event={event}
                              show={videoModalShow}
                              setVideoUrl={setVideoUrl}
                              onHide={() => setVideoModalShow(false)}
                            />
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      </div>
      <br />
      <div className="container">
        <div style={{ overflowX: "auto" }}>
          <Table striped bordered hover variant="dark">
            <thead>
              <tr>
                <th className="text-primary">Name</th>
                <th className="text-primary">Email</th>
                <th className="text-primary">Judge Mark </th>
                <th className="text-primary">User Votes </th>
                <th className="text-primary">Mark (Final) </th>
              </tr>
            </thead>
            <tbody>
              {auditionParticipants &&
                auditionParticipants.map((auditionParticipant, parentIndex) => (
                  <tr key={parentIndex}>
                    <td>
                      {auditionParticipant.user?.first_name +
                        " " +
                        auditionParticipant.user?.last_name}
                    </td>
                    <td>{auditionParticipant?.user?.email}</td>

                    <td>
                      <div>
                        {auditionParticipant?.user_uploaded_video?.map(
                          (video, index) => (
                            <span
                              key={index}
                              className="badge rounded-pill bg-primary ml-1"
                            >
                              Video -{`${index + 1}`} :
                              {video?.judge_video_mark
                                ?.reduce(
                                  (
                                    prevMark,
                                    currMark,
                                    index,
                                    judge_video_mark
                                  ) =>
                                    prevMark +
                                    currMark.judge_mark /
                                      judge_video_mark.length,
                                  0
                                )
                                .toFixed(2)}
                            </span>
                          )
                        )}
                        {videoType == "general" ? (
                          <>
                            <span className="badge rounded-pill bg-info ml-1">
                              Avg:
                              {auditionParticipant?.user_uploaded_video
                                ?.reduce(
                                  (a, v) =>
                                    (a =
                                      a +
                                      v?.judge_video_mark?.reduce(
                                        (
                                          prevMark,
                                          currMark,
                                          index,
                                          judge_video_mark
                                        ) => {
                                          return (
                                            prevMark + currMark.judge_mark / 3
                                          );
                                        },
                                        0
                                      )),
                                  0
                                )
                                .toFixed(2)}
                            </span>
                          </>
                        ) : (
                          "00"
                        )}
                      </div>
                    </td>

                    <td>
                      {auditionParticipant?.user_uploaded_video?.map(
                        (video, index) => (
                          <span
                            key={index}
                            className="badge rounded-pill bg-primary ml-1"
                          >
                            Video ~{`${index + 1}`} :
                            {video?.total_user_vote_react?.map((react) => {
                              return react.react_num;
                            })}
                          </span>
                        )
                      )}
                    </td>

                    <td>
                      <div>
                        {auditionParticipant?.user_uploaded_video?.map(
                          (video, index) => (
                            <span
                              key={index}
                              className="badge rounded-pill bg-primary ml-1"
                            >
                              Video -{`${index + 1}`} :
                              {video.user_judge_total_mark}
                            </span>
                          )
                        )}
                        {videoType == "general" ? (
                          <>
                            <span className="badge rounded-pill bg-info ml-1">
                              Avg :
                              {auditionParticipant?.user_uploaded_video
                                ?.reduce(
                                  (prevMark, currMark) =>
                                    (prevMark =
                                      prevMark +
                                      (currMark.user_judge_total_mark == null
                                        ? 0
                                        : Number(
                                            currMark.user_judge_total_mark
                                          ))),
                                  0
                                )
                                .toFixed(2)}
                            </span>
                          </>
                        ) : (
                          "00"
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>

        <div className="row justify-content-center">
          {isAbleToMerge?.length <= 0 ? (
            <>
              <div className="col-md-12">
                <ReUseableAuditionHeaderTitle
                  isPrimary={false}
                  title={
                    "Round " +
                    auditionRoundInfo?.round_num +
                    " - Make result for next round"
                  }
                />
                <div className="row mx-1 my-3 card-bg justify-content-center py-4">
                  <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
                    <div className="card-bg px-3">
                      <b className="text-light">Take</b>
                    </div>
                  </div>
                  <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
                    <div className="d-flex card-bg px-3 justify-content-around">
                      <button
                        onClick={decrement}
                        className="btn btnDecrement bold"
                      >
                        <i class="fa-solid fa-minus"></i>
                      </button>
                      <input
                        type="number"
                        value={count}
                        onChange={(e) => handleCountChange(e)}
                        className="text-center border-0 from-control bg-black fw-bold btnInput"
                      />
                      <button
                        onClick={increment}
                        className="btn btnIncrement bold"
                      >
                        <i class="fa-solid fa-plus"></i>
                      </button>
                    </div>
                  </div>
                  <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
                    <div className="card-bg px-3">
                      <b className="text-light">
                        % mark gained user for the next round
                      </b>
                    </div>
                  </div>

                  <Button
                    text={"View Result"}
                    onClick={viewResultByPercentage}
                  />
                </div>
              </div>

              <div className="col-md-12">
                <ReUseableAuditionHeaderTitle
                  isPrimary={false}
                  title={
                    "Round " +
                    auditionRoundInfo?.round_num +
                    " - Make result for next round"
                  }
                />

                <div className="row mx-1 my-3 card-bg justify-content-center py-4">
                  <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
                    <div className="card-bg px-3">
                      <b className="text-light">Top</b>
                    </div>
                  </div>
                  <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
                    <div className="d-flex card-bg px-3 justify-content-around">
                      <button
                        onClick={decrementNumber}
                        className="btn btnDecrement bold"
                      >
                        <i class="fa-solid fa-minus"></i>
                      </button>
                      <input
                        value={filterNumber}
                        onChange={(e) => handleFilterNumberChange(e)}
                        className="text-center border-0 from-control bg-black fw-bold btnInput"
                      />
                      <button
                        onClick={incrementNumber}
                        className="btn btnIncrement bold"
                      >
                        <i class="fa-solid fa-plus"></i>
                      </button>
                    </div>
                  </div>
                  <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
                    <div className="card-bg px-3">
                      <b className="text-light">
                        user qualify for the next round
                      </b>
                    </div>
                  </div>
                  <Button
                    text={"View Result"}
                    onClick={viewResultByFilterNumber}
                  />
                </div>
              </div>

              {roundMarkTrackings.length > 0 ? (
                <div className="row justify-content-center align-items-center mt-5">
                  <Card
                    number={auditionParticipants.length}
                    title={"Total User"}
                    cardText={"User"}
                  />
                  <Card
                    number={roundMarkTrackings.length}
                    title={"Qualify For The Next Round"}
                    cardText={"User"}
                  />
                  <Card
                    number={
                      auditionParticipants.length - roundMarkTrackings.length
                    }
                    title={"Disqualify For This Round"}
                    cardText={"User"}
                  />

                  {videoType == "general" ? (
                    <>
                      {Number(auditionRoundInfo?.manager_status) != 0 ? (
                        <Button text={"Already Sent To Manager"} already={0} />
                      ) : (
                        <Button
                          text={"Approved Request For Manager"}
                          onClick={userSendToManager}
                        />
                      )}
                    </>
                  ) : (
                    <>
                      {Number(auditionRoundInfo?.appeal_manager_status) != 0 ? (
                        <Button text={"Already Sent To Manager"} already={0} />
                      ) : (
                        <Button
                          text={"Approved Request For Manager"}
                          onClick={userSendToManager}
                        />
                      )}
                    </>
                  )}
                </div>
              ) : (
                <></>
              )}
            </>
          ) : (
            <Button text="Merge Result" onClick={makeConfirm} />
          )}
        </div>
      </div>
    </>
  );
};

export default AuditionLiveRoundJudgeAssessment;
